import { Modal } from 'antd';
import React, { useState } from 'react';
import ReactPlayer from 'react-player'
import adVideoUrl from '../../assests/adVideo/16mb.mp4';

const AdVideo = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <a onClick={showModal}>
      <font color="#546873">
        {props.children}
      </font>
      </a>

      <Modal 
      visible={isModalOpen}  
      onCancel={handleCancel} 
      footer={null} 
      closeIcon={null}
      className={"ant-modal--video"}
      width={"auto"}
      >
        
      <ReactPlayer id='adVideo' 
                   url={adVideoUrl} playing={true} controls width={"100%"}
                />
      </Modal>
      
    </>
  );
};
  export default AdVideo;